const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://kj86gy7u94.execute-api.us-west-2.amazonaws.com/prod',
    TARGET_API_URL: 'https://t6aqznlj3e.execute-api.us-west-2.amazonaws.com/api',
    TEAMS_APP_URL: 'https://teams.newmont.forwoodsafety.com/teams',
    QS_DASHBOARD_URL: '',
    CLIENT_TIMEZONE: 'America/Sao_Paulo'
  },
  reactApp: {
    VERSION: 'targets-1.12.1',
    HOSTNAME: 'https://targets.newmont.forwoodsafety.com'
  }
};

export default config;